import { Box, styled } from '@mui/material';

export const Wrapper = styled(Box)(({ theme }) => ({
	backgroundColor: theme.palette.common.white,
	boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 10px',
}));
